const arrayRecurcive = (obj, dirs, pathArray, i = 0) => {
  if (Array.isArray(obj)) {
    
    for (let index = 0; index < obj.length; index++) {
      const element = obj[index];

      if (element.label === pathArray[i]) {
        if (i + 1 === pathArray.length) {
          element.children = dirs;
          return;
        }
        arrayRecurcive(element.children, dirs, pathArray, ++i)
        return;
      }
    }

  } else {
    arrayRecurcive(obj.children, dirs, pathArray, i)
  }
}

export default arrayRecurcive